export default __webpack_public_path__ + "medical-treatment89647f.jpg";